var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyBox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    viewBox: "0 0 81 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M40.3999 78c18.2255 0 33-7.835 33-17.5s-14.7745-17.5-33-17.5-33 7.835-33 17.5 14.7746 17.5 33 17.5",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m18.7988 22.8974-6.3989-8.3089 16.0449-9.2428L40.5845 9.739zM40.595 9.8336l22.242 13.0841 5.8683-8.3619-15.9069-9.2745z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.5208 35.44.0636 27.2295 22.2208-12.9568V22.4004"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m40.5208 35.44.0636 27.2295 22.2208-12.9568V22.4004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M40.5843 62.6697 18.2256 49.7659s0-15.8856.1591-15.8537c.1592.0424 22.2102 2.43 22.2102 2.43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEEBF5",
    stroke: "#0061AF",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.7138 22.7051 40.5845 35.63l-12.1822 3.99-15.9599-9.1472zM40.5845 35.63l13.0523 4.0219 15.4823-9.3595-6.6534-7.5873z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-box.b8909b6d7c9ee38e8be2dc389e608a31.svg";